import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import {PeriodosContable , PeriodosContablePagingRes} from '@/shared/interfaces/erp';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError  } from '@/shared';


const { get, post, put } = erpApi();

///* tanSctack query
export const usefetchPeriodosContables = (params?: GetPeriodosContablesParams) => {
    return useQuery({
      queryKey: ['PeriodosContables', ...Object.values(params || {})],
      queryFn: async () => {
        return getPeriodosContables(params);
      },
    });
  };
  
  export const useGetPeriodosContable = (id: string) => {
    return useQuery({
      queryKey: ['PeriodosContables', id],
      queryFn: async () => {
        return getPeriodosContable(id);
      },
    });
  };
  
  export const useCreatePeriodosContables = (
    navigate: NavigateFunction,
    returnUrl: string,
    enableNavigation = true
  ) => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: createPeriodosContables,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['PeriodosContables'] });
        enableNavigation && navigate(returnUrl, { replace: true });
      },
      onError: error => {
        handleAxiosError(error);
      },
    });
  };
  
  export const useUpdatePeriodosContables = (
    navigate: NavigateFunction,
    returnUrl: string,
    noState?: boolean,
    enableNavigation?: boolean
  ) => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: updatePeriodosContables,
      onSuccess: () => {
        noState && queryClient.invalidateQueries({ queryKey: ['PeriodosContables'] });
        enableNavigation && navigate(returnUrl, { replace: true });
      },
      onError: error => {
        handleAxiosError(error);
      },
    });
  };
  
  ///* axios
  export type GetPeriodosContablesParams = {
    page?: number,
    page_size?:number,
  };
  
  export type CreatePeriodosContablesParams = Omit<PeriodosContable, 'id_periodo_contable'>;
  export type UpdatePeriodosContablesParams = {
    id: number;
    data: Omit<PeriodosContable, 'id_periodo_contable'>;
  };
  
  export const getPeriodosContables = async (params?: GetPeriodosContablesParams) => {
    const queryParams = getUrlParamsFetch({ ...params });
  
    return get<PeriodosContablePagingRes>(
      `${urlBackend}api/v1/periodocontable/?${queryParams}`,
      true
    );
  };
  
  export const getPeriodosContable = async (id: string) => {
    try{
      return await get<PeriodosContable>(`${urlBackend}api/periodocontable/${id}/`, true);
    }
    catch(error){
      return handleAxiosError(error);
    }
  };
  
  export const createPeriodosContables = async (data: CreatePeriodosContablesParams) => {
    const setAlert = useUiStore.getState().setAlert;
    const res = await post<PeriodosContable>(`${urlBackend}api/v1/periodocontable/`, data, true);
  
    setAlert(true, res.message, res.status);
    return res;
  };
  
  export const updatePeriodosContables = async (params: UpdatePeriodosContablesParams) => {
    const setAlert = useUiStore.getState().setAlert;
    const res = await put<PeriodosContable>(
      `${urlBackend}api/v1/periodocontable/${params.id}/`,
      params.data,
      true
    );
  
    setAlert(true, res.message, res.status);
    return res;
  };
  